import { mutationTypes, actionTypes, getterTypes } from '../../../types';
import { logger } from '../../../tools/logger';
import { BLUETOOTH_ENABLE_RESULT } from '../../../tools/consts';

export default store => {
	// native Callbacks APIv18  dynamic permission request handling
	window.startBluetooth = function() {
		logger.log('startBluetooth');
		store.dispatch(actionTypes.startBluetooth);
	};
	/**
	 *"enabled" (user enabled GPS)
	 *"denied" (user did not want GPS)
	 "agreed" (user agreed to enable GPS, but the actual outcome is unsure)
	 "already-on" (GPS was already on)
	 "not-available" (GPS is not available)
	 "hardware-error" (user tried to enable GPS, but there was hardware error)
	 */
	window.nativeOnBluetoothEnable = function(result) {
		logger.log(`nativeOnBluetoothEnable: ${result}`);
		switch (result) {
			case BLUETOOTH_ENABLE_RESULT.enabled: {
				if (store.state.bluetooth.config.activateBluetooth) store.dispatch(actionTypes.startBluetooth);
				break;
			}
		}
	};

	window.nativeOnBluetoothStateChanged = function(isEnabled) {
		logger.log(`nativeOnBluetoothStateChanged: ${isEnabled}`);
	};

	// dynamic intervall so no restart is needed for scanIntervall change
	let dynamicIntervall;

	function setDynamicScanIntervall() {
		// logger.log(`setDynamicScanIntervall: ${store.state.bluetooth.config.scanInterval}`);
		dynamicIntervall = setTimeout(() => {
			// Periodically performed scan step so ios and andoid have same update intervall with some filtering
			store.commit(mutationTypes.bluetoothScanStep);
			if (store.state.bluetooth.isActive) {
				setDynamicScanIntervall();
			}
		}, store.state.bluetooth.config.scanInterval);
	}

	let hasProximity = false;
	// functions called by native App
	window.nativeOnBluetoothIOSScanResult = function(shoutrBeaconURL, rssi, accuracy, proximity) {
		// timeOfLastScanResult = performance.now();
		// logger.log(`nativeOnBluetoothIOSScanResult: ${shoutrBeaconURL} RSSI: ${rssi}`);
		hasProximity = true;
		bluetoothScanResult(shoutrBeaconURL, undefined, parseFloat(rssi), undefined, accuracy, proximity);
	};
	window.nativeOnBluetoothScanResult = function(shoutrBeaconURL, mac, rssi, power) {
		// timeOfLastScanResult = performance.now();
		// logger.log(`nativeOnBluetoothScanResult: ${shoutrBeaconURL} RSSI: ${rssi}`);
		if (!hasProximity) {
			bluetoothScanResult(shoutrBeaconURL, mac, parseFloat(rssi), power, undefined, undefined);
		}
	};

	function bluetoothScanResult(shoutrBeaconURL, mac, rssi, power, accuracy, proximity) {
		if (rssi === 0 || !store.state.bluetooth.isActive) {
			return; // DO Nothing cause singal strength is to old oe Interface Not started
		}
		store.commit(mutationTypes.bluetoothRawScan, {
			shoutrBeaconURL,
			mac,
			rssi,
			power,
			accuracy,
			proximity,
		});
		const beaconDesc = store.state.bluetooth.beaconDescription[shoutrBeaconURL];
		if (!beaconDesc) {
			return;
		}
		let currentbeacon = store.state.bluetooth.config.mergeExhibitionBeacons
			? store.state.bluetooth.beaconDescription[beaconDesc.url] ||
			  store.state.bluetooth.beaconDescription[beaconDesc.extendedURL]
			: store.state.bluetooth.currentBeaconDescriptionSubset[beaconDesc.url] ||
			  store.state.bluetooth.currentBeaconDescriptionSubset[beaconDesc.extendedURL];
		if (
			store.state.bluetooth.config.onlyExhibitionBeacons &&
			!currentbeacon
			// &&
			// beaconDesc.type !== 'blocker' &&
			// beaconDesc.type !== 'area'
		) {
			// Filter only Exhibiton beacons
			return;
		}
		store.commit(mutationTypes.bluetoothUpdateRawDetecedBeacons, {
			beaconDesc,
			shoutrBeaconURL,
			mac,
			rssi,
			power,
			accuracy,
			proximity,
		});
	}

	//

	store.subscribe((mutation, state) => {
		switch (mutation.type) {
			case mutationTypes.setDatasource: {
				// Initial Bluetooth commit;
				store.commit(mutationTypes.bluetoothSetBeaconDescription, {
					beaconDescription: state.dataSourceCFG.beaconDescription.reduce((acc, [key, val]) => {
						acc[key] = val;
						return acc;
					}, {}),
				});
				const config = Object.assign({}, store.getters[getterTypes.globalConfig].beaconSettings);
				// delete config.nearestBeaconAlgParameters;
				store.commit(mutationTypes.bluetoothSetScanConfig, config);
				break;
			}
			case mutationTypes.nativeInterfaceUp: {
				if (state.bluetooth.config.activateBluetooth) {
					store.dispatch(actionTypes.startBluetooth);
				} else {
					store.dispatch(actionTypes.stopBluetooth);
				}
				break;
			}
			case mutationTypes.setExhibitionID: {
				logger.log('LOAD SUBSET', store.getters[getterTypes.currentExhibition]);
				if (store.getters[getterTypes.currentExhibition]) {
					const beaconDescription = store.getters[getterTypes.currentExhibition].beacons
						? store.getters[getterTypes.currentExhibition].beacons.reduce((acc, [key, val]) => {
								acc[key] = val;
								return acc;
						  }, {})
						: {};
					store.commit(mutationTypes.bluetoothSetBeaconDescriptionSubset, {
						beaconDescription,
					});
				}
				break;
			}
			case mutationTypes.bluetoothSetScanConfig: {
				store.commit(
					mutationTypes.nearestBeaconSetConfig,
					state.dataSourceCFG.global.beaconSettings.nearestBeaconAlgParameters
				);
				if (state.hasNativeInterface) {
					if (state.bluetooth.config.activateBluetooth) {
						store.dispatch(actionTypes.startBluetooth);
					} else {
						store.dispatch(actionTypes.stopBluetooth);
					}
				}
				break;
			}
			case mutationTypes.bluetoothStart: {
				setDynamicScanIntervall();
				break;
			}
			case mutationTypes.bluetoothStop: {
				clearTimeout(dynamicIntervall);
				break;
			}
			case mutationTypes.bluetoothToggle: {
				if (store.state.bluetooth.isActive) {
					setDynamicScanIntervall();
				} else {
					clearTimeout(dynamicIntervall);
				}
				break;
			}
		}
	});
};
